import clsx from "clsx";
import React from "react";

interface SelectorProps {
  onChangeIndex: (val: number) => void;
  title: string;
}

export function Selector({ onChangeIndex, title }: SelectorProps) {
  return (
    <div className="w-full relative mb-12 flex justify-between items-center ">
      <div className="w-8">
        <ArrowBtn direction="left" onClick={() => onChangeIndex(-1)} />
      </div>
      <div>
        <h2 className="text-2xl">{title}</h2>
      </div>
      <div className="w-8">
        <ArrowBtn direction="right" onClick={() => onChangeIndex(1)} />
      </div>
    </div>
  );
}

interface ArrowBtnProps {
  onClick: () => void;
  direction: "left" | "right";
  className?: string;
}
function ArrowBtn({ onClick, direction }: ArrowBtnProps) {
  return (
    <button
      onClick={onClick}
      className={clsx(
        "justify-center flex align-middle rounded-full border-2 w-8 h-8",
        {
          "rotate-180": direction === "left",
          "": direction === "right",
        }
      )}
      style={{ borderColor: "#eaeaea" }}
    >
      <img
        src={require("../../../../assets/icons/arrow.png")}
        className="h-[28px] w-[18px] p-[4px]"
        alt="pil"
      />
    </button>
  );
}
